const notFound = r => require.ensure([], () => r(require('../views/404.vue')), 'notFound')
const consultationLogin = r => require.ensure([], () => r(require('../views/pageTransfer.vue')), 'consultationLogin')
const logging = r => require.ensure([], () => r(require('../views/pageTransfer.vue')), 'logging')
const login = r => require.ensure([], () => r(require('../views/Login.vue')), 'login')
const layout = r => require.ensure([], () => r(require('../layout/index.vue')), 'layout')
// const home = r => require.ensure([], () => r(require('../views/Home.vue')), 'home')
const homeNew = r => require.ensure([], () => r(require('../views/Home-new.vue')), 'homeNew')
const resetpassword = r => require.ensure([], () => r(require('../views/Resetpassword.vue')), 'resetpassword')
const register = r => require.ensure([], () => r(require('../views/Register.vue')), 'register')
const sysdesc = r => require.ensure([], () => r(require('../views/sysdescription.vue')), 'sysdesc')
const userinfo = r => require.ensure([], () => r(require('../views/user/userInfo.vue')), 'userinfo')
const error = r => require.ensure([], () => r(require('../views/error.vue')), 'error')
// const password = r => require.ensure([], () => r(require('../views/user/changePassword.vue')), 'password')

let routes = [
  { path: '*', redirect: { path: '/404' }, name: '404', hidden: true },
  { path: '/home/index', component: homeNew, name: '首页', hidden: true,  },
  {
    path: '/',name: '主页', hidden: true, redirect: '/home/index', children: [
      // { path: '/login', component: login, name: '登录', hidden: true },
      // { path: 'home/index', component: home, name: '首页', hidden: true, meta: { title: 'home' } }
    ]
  },
  {
    path: '/system',name: '系统信息', component: layout, hidden: true, children: [
      { path: 'sysdesc', component: sysdesc, name: '系统信息', hidden: true, meta:{title: '系统信息'}}
    ]
  },
  {
    path: '/user',name: '用户中心', component: layout, hidden: true, children: [
      { path: 'info', component: userinfo, name: '用户信息', hidden: true, meta:{title: '用户信息'}},
      { path: 'password', component: resetpassword, name: '修改密码', hidden: true, meta:{title: '修改密码'}}
    ]
  },
  { path: '/login', component: login, name: '登录', hidden: true },
  { path: '/register', component: register, name: '注册', hidden: true },
  { path: '/consultationLogin', component: consultationLogin, name: '登录中', hidden: true },
  { path: '/logging', component: logging, name: '调用登录中', hidden: true },
  { path:'/hisLogin',component:logging,name: '调用登录中', hidden: true},
  { path:'/sm2login',component:logging,name: '调用登录中', hidden: true},
  { path:'/lzHisLogin',component:logging,name: '调用登录中', hidden: true},
  { path:'/luLogin',component:logging,name: '调用登录中', hidden: true},
  { path: '/404', component: notFound, name: '404', hidden: true },
  { path: '/error', component: error, name: 'error', hidden: true }
]

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js